export default {"src":"/_next/static/media/request-send-icon.9d2b0429.svg","height":144,"width":202};